var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescriptionSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0V0.611111H0V1.83333H0.625V9.77778C0.625 10.1019 0.756696 10.4128 0.991116 10.642C1.22554 10.8712 1.54348 11 1.875 11H8.125C8.45652 11 8.77446 10.8712 9.00888 10.642C9.2433 10.4128 9.375 10.1019 9.375 9.77778V1.83333H10V0.611111H6.875V0H3.125ZM1.875 1.83333H8.125V9.77778H1.875V1.83333ZM3.125 3.05556V8.55556H4.375V3.05556H3.125ZM5.625 3.05556V8.55556H6.875V3.05556H5.625Z",
    fill: "#234BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionSub);
export default __webpack_public_path__ + "static/media/description-sub.8fdf81c4c8477c14707b19851145edd6.svg";
export { ForwardRef as ReactComponent };